import { Component, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-budget-list",
  templateUrl: "./budget-list.component.html",
  styleUrls: ["./budget-list.component.css"],
})
export class BudgetListComponent implements OnInit, OnDestroy {
  @Output() viewBudget = new EventEmitter<{ budgetId: number; comparison: boolean }>();
  @Output() openMyBudget = new EventEmitter<void>();

  budgets: any[] = [];
  loading = false;
  pageIndex = 1;
  totalPages = 1;
  pageSize = 10;

  // Filters
  searchName = "";
  searchDateCreated = "";
  searchDateValue: Date | null = null;
  searchUser = "";
  searchEmail = "";

  months = {
    1: "Ian", 2: "Feb", 3: "Mar", 4: "Apr", 5: "Mai", 6: "Iun",
    7: "Iul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec",
  };

  private filterSubject = new Subject<void>();
  private destroy$ = new Subject<void>();

  constructor(
    private apiBackend: ApiBackendService,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {
    this.filterSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.pageIndex = 1;
      this.loadBudgets();
    });
    this.loadBudgets();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadBudgets(): void {
    this.loading = true;
    const filterQuery: any = {};
    if (this.searchName) filterQuery.searchName = this.searchName;
    if (this.searchDateCreated) filterQuery.searchDateCreated = this.searchDateCreated;
    if (this.searchUser) filterQuery.searchUser = this.searchUser;
    if (this.searchEmail) filterQuery.searchEmail = this.searchEmail;

    this.apiBackend.getBudgetsPaginated(this.pageSize, this.pageIndex, filterQuery).subscribe(
      (res) => {
        this.budgets = res.body.results || [];
        this.totalPages = res.body.total_pages || 1;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.message.error("Eroare la încărcarea bugetelor");
      }
    );
  }

  onPageChange(page: number): void {
    this.pageIndex = page;
    this.loadBudgets();
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size;
    this.pageIndex = 1;
    this.loadBudgets();
  }

  onFilterChange(): void {
    this.filterSubject.next();
  }

  onDateFilterChange(date: Date | null): void {
    this.searchDateValue = date;
    if (date) {
      this.searchDateCreated = date.toISOString().replace('Z', 'z');
    } else {
      this.searchDateCreated = "";
    }
    this.pageIndex = 1;
    this.loadBudgets();
  }

  getPeriodLabel(budget: any): string {
    const startLabel = this.months[budget.periodStartMonth] || budget.periodStartMonth;
    const endLabel = this.months[budget.periodEndMonth] || budget.periodEndMonth;
    return `${startLabel} ${budget.periodStartYear} - ${endLabel} ${budget.periodEndYear}`;
  }

  onViewBudget(budgetId: number): void {
    this.viewBudget.emit({ budgetId, comparison: false });
  }

  onViewComparison(budgetId: number): void {
    this.viewBudget.emit({ budgetId, comparison: true });
  }
}
